import { isObject } from "lodash";
import { NullValue } from "./../../../ricos-schema/legacy/wix/rich_content/v1";
const isBoolValue = (val) => typeof val.boolValue === "boolean";
const isStringValue = (val) => typeof val.stringValue === "string";
const isNumberValue = (val) => typeof val.numberValue === "number";
const isArrayValue = (val) => {
  var _a;
  return isObject(val.listValue) && Array.isArray((_a = val.listValue) == null ? void 0 : _a.values);
};
const isStructValue = (val) => {
  var _a;
  return isObject(val.structValue) && isObject((_a = val.structValue) == null ? void 0 : _a.fields);
};
const isNullValue = (val) => val.nullValue === NullValue.NULL_VALUE;
export {
  isArrayValue,
  isBoolValue,
  isNullValue,
  isNumberValue,
  isStringValue,
  isStructValue
};
//# sourceMappingURL=struct-refined-types.js.map
